var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookWhite32X32 = function SvgFacebookWhite32X32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 20963",
    width: 32,
    height: 32,
    rx: 6,
    fill: "none",
    opacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 11.213h1.347V8.934a18.709 18.709 0 0 0-1.964-.1 3.073 3.073 0 0 0-3.281 3.368v1.877h-2.2v2.555h2.2v6.53h2.637v-6.53h2.193l.33-2.551h-2.523v-1.631c0-.752.2-1.239 1.261-1.239Z"
  })));
};
export default SvgFacebookWhite32X32;